<ng-container *ngIf="isLoading">
    <div class="loader-container non-transparent">
      <div class="rounded-lg bg-white p-8 shadow-md">
        <div class="loader"></div>
      </div>
    </div>
</ng-container>
  